import Permissions from '@/permissions'

const pLogsViewer = Permissions.backend.setting.logsViewer

const getMeta = (permissions, link) => {
  return {
    permissions,
    groups: 'logs-viewer',
    header: {
      en: 'Logs Viewer',
      km: 'កំណត់ហេតុបញ្ហា'
    },
    breadcrumb: [
      {
        name_en: 'Settings',
        name_km: 'ការកំណត់'
      },
      {
        name_en: 'Logs Viewer',
        name_km: 'កំណត់ហេតុបញ្ហា'
      },
      link
    ]
  }
}

export const logsViewerRouters = {
  path: 'logs-viewer',
  component: () => import('@/views/settings/logsViewer/index'),
  redirect: 'logs-viewer',
  meta: {
    permissions: [pLogsViewer.manage],
    groups: 'logs-viewer'
  },
  children: [
    {
      path: '',
      name: 'list-logs-viewer',
      component: () => import('@/views/settings/logsViewer/list'),
      meta: getMeta([pLogsViewer.list], {
        name_en: 'List',
        name_km: 'បញ្ជី'
      })
    },
    {
      path: 'show/:date',
      name: 'show-logs-viewer',
      component: () => import('@/views/settings/logsViewer/show'),
      meta: getMeta([pLogsViewer.show], {
        name_en: 'Show',
        name_km: 'មើល'
      })
    }
  ]
}
